<template>
  <div style="height:100%;background-color: #5baa3c">
    <!-- <van-nav-bar
        @click-left="toHome"
                  title="收款"  right-text="按钮"
                  left-arrow/> -->

      <van-nav-bar
        title="收款"
        left-text="返回"
        right-text="完成"
        left-arrow
        @click-left="toHome"
        @click-right="getmodel('order')"/>

    <div style="margin:22px;padding-top:30px;padding-bottom:30px;background-color: white;border-radius:25px;" >
      <van-row justify="center">
        <van-col style="text-align: center" span="24"><img src="../../style/img/sk2.svg" @click="sweep" ></van-col>
        <!-- <van-col style="text-align: center" span="12"><img src="../../style/img/sk3.svg"></van-col> -->
        <!-- <van-col style="text-align: center" span="8" @click="getmodel('order')">
          <img src="../../style/img/sk1.svg"></van-col> -->
      </van-row>
      <van-row justify="center">
        <van-col style="text-align: center;color: #5baa3c" span="24" @click="sweep" >扫码收款</van-col>
        <!-- <van-col style="text-align: center;color: #5baa3c" span="12" @click="startCode">收款码</van-col> -->
        <!-- <van-col style="text-align: center;color: #5baa3c" span="8"  
        @click="getmodel('order')">数据收集</van-col> -->
    
      </van-row>
      <div style="margin-left: 30px;text-align: center;margin: 20px 82px">
        <div id="qrcode" ref="qrcode"></div>
      </div>
      <div style="text-align: center">订单金额：￥{{orderZje}}</div>
    </div>
    <div style="margin-top:50px;background-color: white;">
    </div>
    <van-dialog  v-model="popUpDisplay" title="现金收取" confirmButtonColor="#1989fa" 
      show-cancel-button  @confirm="cash()">
        <van-field  type="number" readonly v-model="monery" label="收款金额" placeholder="请输入收款金额" />
     </van-dialog>
  </div>
</template>

<script>
import {Card, Col, Field, Overlay, Row, Toast,Dialog } from 'vant'
import {Indicator} from "mint-ui";
import QRCode from "qrcodejs2";
import wx from "weixin-jsapi";
export default {
  components: {
    [Row.name]:Row,
    [Col.name]:Col,
    [Card.name]:Card,
    [Overlay.name]:Overlay,
    [Field.name]:Field,
    [Dialog.Component.name]: Dialog.Component,
  },

  data() {
    return {
      order: {},
      value: '',
      monery: '',
      snCode:'',
      popUpDisplay: false,
      orderInfo: [],
      orderZje:'',
      orderId:''
      // payType: 'wxpay'
    };
  },
  created() {
     this.orderZje=sessionStorage.getItem("orderZje");
     this.monery=this.orderZje;
     this.orderId=this.$route.query.orderId;
    // this.startCode();   //初始化生成二维付款码
  },
 
  methods: {

      start() {
      // 将定时器名字赋值到变量中
      this.timer = setInterval(() => {
        console.log("开始---");
      }, 1000);
    },
    sweep() {  //开始扫描
      const url =
          "http://www.fjfapiao.com:2018/fjbw/sbsp/api/wxTitle?urls=" +
          location.href.split("#")[0];
      console.log("rl:::", location.href.split("#")[0])
      var that = this;
      Indicator.open({
        text: "授权中...",
        spinnerType: "fading-circle"
      });
      setTimeout(() => {
        Indicator.close();
      }, 60000);
      that.$axios
          .post(url)
          .then((data) => {
            if (data.code == 200) {
              Indicator.close;
              var timestamp = data.data.timestamp;
              var noncestr = data.data.nonceStr;
              var signature = data.data.signature;
              var appId = data.data.appId;
              console.log('返回结果了');
              wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: appId, // 必填，公众号的唯一标识
                timestamp: timestamp, // 必填，生成签名的时间戳
                nonceStr: noncestr, // 必填，生成签名的随机串
                signature: signature, // 必填，签名，见附录1
                jsApiList: [
                  "scanQRCode",
                ],
              });
              console.log('开始调用');
              wx.ready(function () {
                console.log('wx.ready');
                wx.scanQRCode({
                  desc: "scanQRCode desc",
                  needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                  scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                  success: function (res) {
                    console.log('res2');
                    const getCode = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                    Indicator.close();
                    that.snCode = getCode;
                    console.log(that.snCode );
                    that.distinguish(getCode);

                  },
                  cancel: function (res){
                    console.log('取消扫码了');
                    Indicator.close();
                  },
                  error: function (res) {
                    console.log('res');
                    console.info(JSON.stringify(res));
                    Indicator.close();
                  },
                });
              });
            } else {
              Indicator.close();
              Toast({
                message: data.message,
                position: "middle",
                duration: 2000,
              });
            }
          })
          .catch((error) => {
            //请求失败返回的数据
            Indicator.close();
            console.log('error');
            Toast({
              message: error.message,
              position: "middle",
              duration: 2000,
            });
          });
    },
    onSubmit(){
      this.$router.push({path: '/collection'});
    },
    cash(){
      if(this.monery===null||this.monery===''){
        Toast("收款金额不能为空")
        return ''
      }
      let ajaxUrl="/memberBusiness/goodsPay/"+this.$route.query.orderId+"/"+this.monery+"/cashPay";
      this.$axios
          .post(ajaxUrl)
          .then((data) => {
            if (data.code == 200) {
                Toast('付款成功');
               this.$router.push({ path: "/order?status=1" });
            } else {
              Toast(data.message);
            }
          })
          .catch((erro) => {
            reject(erro);
          });
    },
    toHome(){
      this.$router.push({ path: "/home" });
    },
    distinguish(code){   //微信扫码之后返回结果提交付款
      let ajaxUrl="/memberBusiness/goodsPay/"+this.$route.query.orderId+"/"+this.$route.query.orderZje+"/"+code+"/wxScan";
      this.$axios
          .post(ajaxUrl)
          .then((data) => {
            if (data.code == 200) {
               Toast('付款成功');
              this.$router.push({ path: "/order?status=1" });
            } else {
              Toast(data.message);
            }
          })
          .catch((erro) => {
            reject(erro);
          });
    },
    onClickLeft(){
      this.$router.push({path: '/home'});
    },
     
    startCode(){  //生成二维码
      let orderId=this.$route.query.orderId;
      let  payMoney=this.orderZje;  
      let ajaxUrl="/memberBusiness/goodsPay/"+orderId+"/"+payMoney+"/wxCode";
      this.$axios
          .post(ajaxUrl)
          .then((data) => {
            if (data.code == 200) {
              setTimeout(() => {
                document.getElementById("qrcode").innerHTML = "";
                var url =data.message;
                let qrcode = new QRCode("qrcode", {
                  width: 200,
                  height: 200,
                  text: url // 二维码地址
                });
              }, 50);

            } else {
              Toast(data.message);
              this.$router.push({path: '/home'});
            }
          })
          .catch((erro) => {
            reject(erro);
          });

    },
  
  }
};

</script>

<style lang="less">
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 100%;
  height: 30%;
  background-color: #fff;
}
.red {
  color: red;
}

.strong {
  font-weight: bold;
}

.van-cell-group {
  margin-top: 10px;
}

.footer {
  position: fixed;
  bottom: 0px;
}
</style>
